const sortByProp = (list, propName, asc = true) => {
  if (asc) return list.sort((a, b) => (a[propName] > b[propName] ? 1 : -1));
  return list.sort((a, b) => (a[propName] < b[propName] ? 1 : -1));
};

export { sortByProp };
